// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "type", "client", "location",  "asset"]
  static values = {templateUrl: String, type: String}

  connect() {
    this.chooseByLocation()
  }

  select(e) {
    if( this.typeTarget.value == "client" ) 
      this.chooseByClient()
    else 
      this.chooseByLocation()
  }

  setLocation(e) {
    const url = this.templateUrlValue.replace("ObjectId", e.target.value.toString()).replace("ObjectType", this.typeValue)
    const el = `
      <select id="bom_company_asset_id" name="bom[company_asset_id]" data-placeholder="Serial Num or Ref" data-ajax--url="${url}" class="select2" style="width: 220px"></select> `
    this.assetTarget.innerHTML=el
    init_select2()
  }

  chooseByClient() {
    this.locationTarget.style.display="none"
    this.locationTarget.querySelector("select").setAttribute("disabled", true)
    this.clientTarget.querySelector("select").removeAttribute("disabled")
    this.clientTarget.style.display="inherit"
    this.typeValue="Client"
  }

  chooseByLocation() {
    this.clientTarget.style.display="none"
    this.clientTarget.querySelector("select").setAttribute("disabled", true)
    this.locationTarget.querySelector("select").removeAttribute("disabled")
    this.locationTarget.style.display="inherit"
    this.typeValue="Misc::StockLocation"
  }

}
